var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrderSuccess = function SvgOrderSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18a849",
    d: "m0 80.062 19.491-57.883 38.5 38.353Z",
    "data-name": "Path 18995"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4502"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3ffc3",
    d: "M54.376 61.138a19.723 19.723 0 0 1-7.075-1.521A48.758 48.758 0 0 1 31.419 48.64a48.766 48.766 0 0 1-10.973-15.878c-2.284-5.835-1.988-10.6.833-13.423s7.587-3.116 13.423-.833a48.76 48.76 0 0 1 15.882 10.977A48.764 48.764 0 0 1 61.56 45.362c2.284 5.835 1.988 10.6-.833 13.423a8.659 8.659 0 0 1-6.351 2.353",
    "data-name": "Path 18997"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4503"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.849 22.379a4.111 4.111 0 0 0-2.974.956c-1.354 1.354-1.265 4.456.239 8.3a49.056 49.056 0 0 0 24.148 24.148c3.843 1.5 6.945 1.593 8.3.239s1.265-4.456-.239-8.3a49.056 49.056 0 0 0-24.148-24.148 15.188 15.188 0 0 0-5.326-1.195",
    "data-name": "Path 18999"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd524",
    d: "m41.509 41.914-3.38-3.381c3.073-3.073 6.18-3.173 8.677-3.254 2.156-.07 3.714-.12 5.45-1.856s1.786-3.294 1.856-5.449c.08-2.5.181-5.6 3.254-8.677s6.18-3.173 8.677-3.254c2.156-.069 3.713-.12 5.449-1.855s1.786-3.294 1.856-5.449c.081-2.5.181-5.6 3.254-8.676l3.381 3.381c-1.736 1.736-1.786 3.294-1.856 5.449-.08 2.5-.181 5.6-3.254 8.677s-6.18 3.173-8.677 3.254c-2.156.069-3.713.12-5.449 1.855s-1.786 3.294-1.856 5.449c-.08 2.5-.181 5.6-3.254 8.677s-6.18 3.173-8.677 3.254c-2.157.069-3.715.119-5.451 1.855",
    "data-name": "Path 19001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7bff",
    d: "M34.281 32.62c-.6-2.072-1.032-3.569.084-5.756s2.582-2.715 4.611-3.446c2.35-.847 5.275-1.9 7.25-5.771s1.112-6.857.419-9.257c-.6-2.072-1.032-3.569.084-5.756L42.47.461c-1.975 3.871-1.112 6.857-.419 9.257.6 2.072 1.032 3.569-.084 5.756s-2.582 2.715-4.611 3.446c-2.35.847-5.274 1.9-7.25 5.771s-1.112 6.858-.419 9.257c.6 2.072 1.032 3.569-.084 5.756a6.974 6.974 0 0 1-.6.984 51.96 51.96 0 0 0 3.082 3.76 11.076 11.076 0 0 0 1.782-2.57c1.97-3.872 1.107-6.858.414-9.258",
    "data-name": "Path 19002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0ae3e3",
    d: "M58.244 50.699c1.956 1.553 4.392 3.487 8.722 3.131s6.417-2.661 8.094-4.512c1.447-1.6 2.493-2.755 4.94-2.956l-.392-4.766c-4.331.356-6.417 2.66-8.094 4.512-1.447 1.6-2.493 2.755-4.94 2.956s-3.667-.768-5.356-2.11c-1.956-1.553-4.39-3.487-8.721-3.131s-6.418 2.66-8.094 4.512c-1.38 1.525-2.4 2.644-4.611 2.919a40.268 40.268 0 0 0 5.046 3.145 16.334 16.334 0 0 0 3.11-2.855c1.448-1.6 2.494-2.755 4.94-2.956s3.667.769 5.356 2.111",
    "data-name": "Path 19003"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.188,
    cy: 3.188,
    r: 3.188,
    fill: "#ffce00",
    "data-name": "Ellipse 157",
    transform: "translate(28.144 7.703)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.188,
    cy: 3.188,
    r: 3.188,
    fill: "#ff7bff",
    "data-name": "Ellipse 158",
    transform: "translate(71.062 56.127)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4504",
    transform: "translate(57.41 4.515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.188,
    cy: 3.188,
    r: 3.188,
    fill: "#42eb7c",
    "data-name": "Ellipse 159",
    transform: "translate(7.173 27.897)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.188,
    cy: 3.188,
    r: 3.188,
    fill: "#0ae3e3",
    "data-name": "Ellipse 160"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#88faae",
    d: "M14.521 39.392a34.657 34.657 0 0 1-.325-1.644L9.805 50.586l.144 3.067c.318 6.54 4.187 15.169 8.6 20.006l18.668-6.319c-.098-.035-.198-.061-.301-.099-11.03-4.577-19.767-16.205-22.395-27.85",
    "data-name": "Path 19004",
    opacity: 0.8
  }))));
};
export default SvgOrderSuccess;